export default __webpack_public_path__ + "static/webRotator/svg/d0fe522a31e2dc3818404171a9587008.svg";